import type { ComboboxOptionType } from '@zillow/constellation-10';
import { FormField, FormHelp, Label } from '@zillow/constellation-10';
import { TimeZoneDropdownSelect, TourDurationDropdownSelect } from '@zg-rentals/touring';
import type { TimeZoneIds } from '@zg-rentals/touring';
import { WizardFormSectionContainer, WizardHeading } from '../../../../styles/wizard';
import type { TourDuration } from '@zg-rentals/ts-z-calendar-client';

type TourSchedulingTimeZoneBodyProps = {
  selectedTimeZone?: TimeZoneIds;
  onSelectTimeZone: (option: ComboboxOptionType) => void;
  selectedTourDuration?: TourDuration;
  onSelectTourDuration: (option: ComboboxOptionType) => void;
};

const TourSchedulingTimeZoneBody = ({
  selectedTimeZone,
  onSelectTimeZone,
  selectedTourDuration,
  onSelectTourDuration,
}: TourSchedulingTimeZoneBodyProps) => {
  return (
    <div data-testid="TourSchedulingTimeZoneBody">
      <WizardFormSectionContainer>
        <WizardHeading level={1} textStyle="heading-sm" data-testid="TourSchedulingTimeZoneBody-Heading">
          Tour settings
        </WizardHeading>

        <FormField
          label={<Label size="lg">Length of each tour</Label>}
          control={
            <TourDurationDropdownSelect tourDuration={selectedTourDuration} handleOptionSelect={onSelectTourDuration} />
          }
          required={true}
          css={{ marginBottom: 'tight' }}
        />
        <FormField
          label={<Label size="lg">Property time zone</Label>}
          description={
            <FormHelp>
              This helps ensure that your tour availability matches what&apos;s provided to interested renters
            </FormHelp>
          }
          control={
            <TimeZoneDropdownSelect
              timeZone={selectedTimeZone}
              handleOptionSelect={onSelectTimeZone}
              disableTimeZoneSelection={false}
            />
          }
          required={true}
          css={{ marginBottom: 'tight' }}
        />
      </WizardFormSectionContainer>
    </div>
  );
};

export default TourSchedulingTimeZoneBody;
